export default __webpack_public_path__ + "static/media/7.49b27306.png";